module.exports = __webpack_public_path__ + "static/img/busca-candidatos-1680x1050.136651f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/candidatos/busca-candidatos-1680x1050.jpg
// module id = JVE0
// module chunks = 47